import Tree from './src/index.vue'

import type { App } from 'vue'
import type { SFCWithInstall } from '@sgui-plus/utils/types'

Tree.install = (app: App): void => {
  app.component(Tree.name, Tree)
}

const _Tree = Tree as SFCWithInstall<typeof Tree>

export default _Tree
export const SgTree = _Tree
